export { TFoot } from "./TFoot";
